<template>
  <div id="top">
    <OrganismsLayoutsHeader />

    <PartsPageNav :items="breadcrumbItems" />

    <main class="main_error">
      <PartsLayoutContainer>
        <PartsLayoutCol2 :main-wrapper="true">
          <!--
            **支給は `sec_survey_input`**（`error.html:...`）。エラー用の section クラスは無く、
            アンケート入力の器を借りている。見出しの修飾も `survey-input-title` のまま。
          -->
          <section class="sec_survey_input">
            <PartsSubPageTitle :title="pageTitle" title-modifier="survey-input-title" />

            <div class="error-area">
              <div class="error-msg">
                <p>ページ表示エラー</p>
                <span
                  >お探しのページが見つからないか、<br class="sp-only" />
                  システムエラーが発生しました。</span
                >
              </div>

              <!-- 原因の切り分け用。本番では出ない（`DevOnly` は dev のみ描画される） -->
              

              <PartsActionBtns>
                <PartsActionBtn to="/" label="トップページへ" direction="next" />
              </PartsActionBtns>
            </div>
          </section>
        </PartsLayoutCol2>
      </PartsLayoutContainer>
    </main>

    <OrganismsLayoutsFooter />
  </div>
</template>

<script setup lang="ts">
/**
 * エラーページ。支給デザイン `error.html`。
 *
 * **`error.vue` は Nuxt の仕様でレイアウトの外**（`layouts/default.vue` が適用されない）ので、
 * 器とヘッダー・フッターを自前で持つ。変換前もそうだった。
 * 器の `id="top"` は `organisms/layouts/header` がメニュー展開時に背後を `inert` にする起点。
 * サイドバーとダイアログは出さない（エラー時に余計なものを描かない。変換前と同じ）。
 *
 * **支給はエラー専用の section クラスを持たず `sec_survey_input` を借りている。**
 * 見出しの修飾も `survey-input-title`。`.main_error` 配下の指定
 * （`renewal/style.css:10039-10084`）が効くので、この組み合わせを崩さない。
 *
 * **見出しの罫線は支給どおり付ける**（`sub-page-title-area title-area-underline`）。
 * アイコンは持たない。
 *
 * **デバッグ表示は `DevOnly` のまま残す**（決定#3）。支給には無いが、本番では描画されない。
 *
 * 旧デザインの `l-main` / `l-1column` / `p-error` / `l-main_inner` / `c-box--noframe` /
 * `u-text--alert` / `c-explain--top` / `c-btn-area` / `c-btn` は付けない。
 */
import type { BreadcrumbType } from '@/types/domains/index';

type Props = {
  error: {
    statusCode: number;
    statusMessage: string;
    message: string;
  };
};

defineProps<Props>();

const pageTitle: string = 'エラー';

const breadcrumbItems: BreadcrumbType.Breadcrumb[] = [
  { text: 'トップ', href: '/' },
  { text: pageTitle, href: null },
];

useSeoMeta({
  title: `${pageTitle}｜オリエンタルバイオ公式オンラインショップ`,
});
</script>

<style scoped>
/**
 * デバッグ表示は支給に無い（本番では `DevOnly` が消す）。
 * `error-area` が `align-items: center` なので、中身が中央に寄るのだけ揃える。
 */
.error-debug {
  width: 100%;
  text-align: center;
  line-height: 1.8;
}
</style>
